import { Injectable } from '@angular/core';
import axios from "axios";
import Promise from "bluebird";
import { CookieService } from 'ngx-cookie-service';

import { JwtHelperService } from "@auth0/angular-jwt";
import { XsMessageBoxComponent } from 'src/app/common/widgets/xs-message-box/xs-message-box.component';
import { MatDialog } from '@angular/material';
import { CoreCommonService } from 'src/app/core/services/core-common.service';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';


@Injectable({
  providedIn: 'root'
})
export class XsHttpApiService {

  constructor(
    private cookieService: CookieService,
    private dialog: MatDialog,
    private coreCommonService: CoreCommonService,
    private xsAppConfigService: XsAppConfigService,
  ) { }

  // JWT
  configurarToken() {
    axios.defaults.headers.common['Authorization'] = 'Basic U3NvQXBwOmIzYjc0NDM0MWE4NzA5MWFkNTRmZjU4ZDY4OTg5OGFk';
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE';
    axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Auth-Token';
    //axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'X-Requested-With,content-type';    
  }

  post(host, urlPart, parametros: any): any {
    this.configurarToken();
    //console.log("POST: REQUEST ----> ", host + urlPart, parametros);
    return new Promise((resolve, reject) => {
      axios
        .post(host + urlPart, parametros)
        .then(data => {
          console.log("POST: RESPONSE <----", data);
          resolve(data);
        })
        .catch(e => {
          reject(e);
        });
    });

    
  }

  get(host, urlPart): any {
    this.configurarToken();
    //console.log("POST: REQUEST ----> ", host + urlPart);
    return new Promise((resolve, reject) => {
      axios
        .get(host + urlPart)
        .then(data => {
          console.log("POST: RESPONSE <----", data);
          resolve(data);
        })
        .catch(e => {
          reject(e);
        });
    });
  }


  postWithHeader(host, urlPart, parametros: any, headers: any): any {
    this.configurarToken();
    //console.log("POST: REQUEST ----> ", host + urlPart, parametros);
    return new Promise((resolve, reject) => {
      axios
        .post(host + urlPart, parametros, headers)
        .then(data => {
          console.log("POST: RESPONSE <----", data);
          resolve(data);
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  postBlob(host, urlPart, parametros: any): any {
    this.configurarToken();
    //console.log("POST: REQUEST exc ----> ", host + urlPart);
    return new Promise((resolve, reject) => {
      axios
        .post(host + urlPart, parametros, { responseType: 'blob' })
        .then(data => {
          console.log("POST: RESPONSE <----", data);
          resolve(data);
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  delete(host, urlPart): any {
    this.configurarToken();
    //console.log("DELETE: REQUEST ----> ", urlPart);
    return new Promise((resolve, reject) => {
      axios
        .delete(host + urlPart)
        .then(data => {
          console.log("DELETE: RESPONSE <----", data);
          resolve(data);
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  // REVISAR PETICION
  checkToken(myRawToken) {
    if (myRawToken) {
      const helper = new JwtHelperService();
      const isExpired = helper.isTokenExpired(myRawToken);
      if (isExpired) {
        this.mostrarMessageBoxToken("ATENCIÓN", "Se ha perdido la session");
      }
    }
  }

  mostrarMessageBoxToken(titulo, mensaje): void {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-dlg-base",
      data: { titulo: titulo, mensaje: mensaje }
    });

    dialogRef.afterClosed().subscribe(resultado => {
      this.onClickCerrarSesion();
    });
  }

  onClickCerrarSesion() {
    let plusdSesionToken = this.cookieService.get('plusdSesionToken');
    this.cookieService.deleteAll();
    localStorage.clear();
/*
    if (this.xsAppConfigService.APLICACION_AMBIENTE == 'localhost-nologin') {
      window.location.href = this.coreCommonService.APPLICATION_APP_HOST;
    } else {
      // window.location.href = this.coreCommonService.APPLICATION_APP_HOST + "/logout?tokenSesion=" + plusdSesionToken;
      // window.location.href = this.coreCommonService.APPLICATION_APP_HOST;
      // window.location.href = "https://sistemas.oefa.gob.pe/sice";
      window.location.href = ""+window.location;
    }*/

    window.location.href = ""+window.location;
  }

}
